import { Component, EventEmitter, Output } from '@angular/core';
import { ToastService } from 'app/core/services/toast/toast.service';
import { NgFor } from '@angular/common';
import { DragDropDirective } from '../directives/drag-drop.directive';

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-files.component.html',
    styleUrls: ['./upload-files.component.scss'],
    imports: [DragDropDirective, NgFor]
})
export class UploadFilesComponent {

  files: any = [];
  filesToShow: any = [];
  @Output() uploadFiles = new EventEmitter();
  @Output() closeDialog = new EventEmitter();

  constructor(
    private toastService: ToastService
  ) {

  }

  uploadFile(event) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];

      if (element.type !== 'application/pdf') {
        this.toastService.info(element.name, 'no es un archivo PDF');
      } else {
        if ((this.filesToShow.find(filename => filename === element.name)) === undefined) {
          const formData: FormData = new FormData();
          formData.append('plan', element);

          this.files.push(formData);
          this.filesToShow.push(element.name);
        }
      }
    }
  }

  deleteAttachment(index) {
    this.files.splice(index, 1);
  }

  sendFilesForUpload() {
    this.uploadFiles.emit(this.files);
  }

  onClose() {
    this.closeDialog.emit();
  }
}
